module.exports = __webpack_public_path__ + "static/media/photo175.ac17787f.jpg";